import { findAndReplace } from 'mdast-util-find-and-replace'
import { Transformer } from 'unified'

export const ELEMENT_EMOJI = 'emoji'

// Improved emoji regex that matches most emoji patterns including:
// - Basic emojis
// - Emojis with skin tone modifiers
// - Multi-part emojis (like family emojis)
// - Flag emojis (regional indicator pairs)
// - Emojis with variation selectors
const EMOJI_REGEX =
    /(?![0-9#*])(\p{Regional_Indicator}{2}|\p{Emoji_Presentation}|\p{Emoji}\uFE0F?)(\u200D(\p{Emoji_Presentation}|\p{Emoji}\uFE0F?)|\p{Emoji_Modifier})*/gu

/**
 * Remark plugin that finds emojis in text content and wraps them in custom emoji elements
 * This allows us to apply custom styling and behavior to emojis
 */
export default function remarkEmoji(): Transformer {
    const transformer: Transformer = (tree, _file) => {
        // Use findAndReplace to search for emoji patterns and replace them with custom elements
        // eslint-disable-next-line
        // @ts-expect-error: replacing ts-ignore
        findAndReplace(tree, [
            [
                EMOJI_REGEX,
                (match: string) => ({
                    type: ELEMENT_EMOJI,
                    emoji: match,
                    value: match,
                    children: [{ text: '' }],
                }),
            ],
        ])
    }

    return transformer
}
